module.exports = __webpack_public_path__ + "media/images/avatar/2-c094d6ffbcf725de1a70ac9242a6b960.svg";